import Vue from 'vue'
import axios from 'axios'
import AuthService from '@/service/auth/AuthService'

const _axios = axios.create({
  baseURL: `${process.env.common.fundaApi.host}`,
})

const DEFAULT_API_ERROR_MESSAGE =
  '요청 처리 중 에러가 발생했습니다. 문제가 지속되면 문의바랍니다.'

_axios.interceptors.request.use(
  config => {
    if (config.isInterceptor !== false) {
      if (
        config.headers.Authorization == null ||
        config.headers.Authorization.startsWith('Basic') === false
      ) {
        let token = localStorage.getItem(process.env.common.token.name)
        if (token != null) {
          config.headers.Authorization = `Bearer ${token}`
        }
      }
    }

    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  resp => {
    let data = resp.data
    if (!!data.errors) {
      let graphQLErr = Array.isArray(data.errors) ? data.errors[0] : data.errors
      let responseErr = graphQLErr

      if (responseErr && responseErr.extensions) {
        responseErr = responseErr.extensions
      }

      if (!responseErr || typeof responseErr !== 'object') {
        responseErr = {
          message: getErrorMessage(responseErr, graphQLErr),
          rawError: responseErr,
        }
      } else {
        responseErr.message = getErrorMessage(responseErr, graphQLErr)
        if (!responseErr.errors && graphQLErr && graphQLErr.errors) {
          responseErr.errors = graphQLErr.errors
        }
      }

      console.log('[fundaApiClient] graphql error', {
        url: resp.config && resp.config.url,
        errors: data.errors,
        normalizedError: responseErr,
      })

      if (responseErr.status === 401) {
        location.reload()
      }
      return Promise.reject(responseErr)
    } else if (!!resp.error) {
      Promise.reject(resp.error)
    } else {
      let r = resolveResp(resp)
      return Promise.resolve(r)
    }
  },
  error => {
    // Do something with response error
    console.log('[fundaApiClient] response error', error)
    return Promise.reject(error.response || error)
  }
)

function resolveResp(resp) {
  if (!!resp && Object.prototype.hasOwnProperty.call(resp, 'data')) {
    resp = resolveResp(resp.data)
  }
  return resp
}

function getErrorMessage() {
  for (let i = 0; i < arguments.length; i++) {
    const message = findErrorMessage(arguments[i])
    if (message) {
      return message
    }
  }
  return DEFAULT_API_ERROR_MESSAGE
}

function findErrorMessage(error) {
  if (!error) {
    return null
  }

  if (typeof error === 'string') {
    const message = error.trim()
    return parseJsonMessage(message) || message || null
  }

  if (Array.isArray(error) && error.length > 0) {
    return getErrorMessage(error[0])
  }

  if (error.errors && error.errors.length > 0) {
    const message = getErrorMessage(error.errors[0])
    if (message) {
      return message
    }
  }

  if (typeof error.message === 'string' && error.message.trim()) {
    return parseJsonMessage(error.message) || error.message
  }

  return null
}

function parseJsonMessage(message) {
  if (!message) {
    return null
  }

  try {
    const parsed = JSON.parse(message)
    if (parsed && typeof parsed.message === 'string' && parsed.message.trim()) {
      return parsed.message
    }
  } catch (e) {}

  return null
}

_axios.call = async function(option) {
  if (option.data != null && option.data.isAwait === false) {
    delete option.data.isAwait
  } else {
    await AuthService.sync()
  }
  return _axios(Vue.util.extend({}, option))
}

export default _axios
